exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.font-small[data-v-135405c7] {\n    font-size: .90rem;\n}\n.header[data-v-135405c7] {\n    line-height: 1;\n}\n.detail[data-v-135405c7] {\n    line-height: 1;\n    font-size: .80rem;\n}\n.fa-sm[data-v-135405c7] {\n     padding-bottom: 3px;\n}\n", ""]);

// exports
